import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=8fb31908&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb31908')) {
      api.createRecord('8fb31908', component.options)
    } else {
      api.reload('8fb31908', component.options)
    }
    module.hot.accept("./ChangePasswordForm.vue?vue&type=template&id=8fb31908&", function () {
      api.rerender('8fb31908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/ChangePasswordForm.vue"
export default component.exports